import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

type SubTitleProps = ComponentProps<"h2">;

export const SubTitle = (props: SubTitleProps) => {
    return (
        <h2
        {...props}
        className={twMerge("text-blue-200 font-semibold", props.className)}
        />
    );
};
